// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".username_top .btn-link:hover {\n  text-decoration: none !important;\n}\n.username_top .btn-link:active {\n  text-decoration: none !important;\n}\n.username_top .btn-link {\n  text-decoration: none !important;\n}\n.topUserDiv .material-icons-outlined {\n  margin-top: -2px;\n}", ""]);
// Exports
module.exports = exports;
